import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {Product} from '@/_application/modules/products/model/product';
import CustomLinkWithArrow from '@/_application/core/components/commons/custom-link-with-arrow';
import {Routes} from '@/config/routes';
import {useTranslation} from 'next-i18next';

export interface NewArrivalProductsProps {
    newArrivalProducts?: Product[];
}

function NewArrivalProducts({newArrivalProducts = []}: NewArrivalProductsProps) {
    const {t} = useTranslation('common');

    if (!newArrivalProducts.length) {
        return null;
    }

    return (
        <>
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                {newArrivalProducts.map(product => (
                    <ProductCard key={product?.sku} product={product} />
                ))}
            </div>
            <div className="mt-5 flex w-full items-center justify-center">
                <CustomLinkWithArrow text={t('text-view-all', 'Xem tất cả')} href={Routes.newArrival} />
            </div>
        </>
    );
}

export default NewArrivalProducts;
